import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useAuthService } from "../../../services/authService";
import { useLanguage } from "../../../context/LanguageContext";
import dashboardContent from "../../../utils/dashboardContent";

const DropdownUser = ({ user }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { userLogout } = useAuthService();
  const { language } = useLanguage();
  const text = dashboardContent[language].dropdownUser;
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef} className="relative">
      <div
        onClick={() => setDropdownOpen(!dropdownOpen)}
        className="flex items-center gap-4 cursor-pointer"
      >
        <span className="hidden text-right lg:block">
          <span className="block text-sm font-medium text-black dark:text-white">
            {user.user.name}
          </span>
          <span className="block text-xs">
            <span
              className={`inline-block px-2 py-0.5 rounded-full text-white text-xs font-semibold
      ${
        user.user.subscription.planName === "premium"
          ? "bg-orange-500"
          : user.user.subscription.planName === "standard"
          ? "bg-blue-500"
          : "bg-gray-400"
      }`}
            >
              {user.user.subscription.planName}
            </span>
          </span>
        </span>

        <span className="h-10 w-10 rounded-full">
          <img
            src={user.user.profilePicture}
            alt="User"
            className="rounded-full h-full w-full"
          />
        </span>
      </div>

      {dropdownOpen && (
        <div className="absolute right-0 mt-2 w-56 flex flex-col rounded-sm border border-stroke bg-white shadow-md dark:border-strokedark dark:bg-boxdark">
          <ul className="flex flex-col border-b border-stroke px-4 py-2 dark:border-strokedark">
            <li>
              <Link
                to="/dashboard/profile"
                className="flex items-center gap-2 py-2 text-sm font-medium text-gray-700 transition hover:text-primary dark:text-white"
              >
                {text.profile}
              </Link>
            </li>
            <li>
              <Link
                to="/dashboard/abomanagement"
                className="flex items-center gap-2 py-2 text-sm font-medium text-gray-700 transition hover:text-primary dark:text-white"
              >
                {text.subscription}
              </Link>
            </li>
            <li>
              <Link
                to="/dashboard/support"
                className="flex items-center gap-2 py-2 text-sm font-medium text-gray-700 transition hover:text-primary dark:text-white"
              >
                {text.support}
              </Link>
            </li>
          </ul>
          <button
            className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 transition hover:text-primary dark:text-white"
            onClick={userLogout}
          >
            {text.logout}
          </button>
        </div>
      )}
    </div>
  );
};

export default DropdownUser;
